import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/AdminLayout";
import { RequestStatusBadge } from "@/components/Badges";
import { api, errMsg, fmtDate } from "@/lib/api";

function RequestCard({ r, onChanged }) {
  const [reply, setReply] = useState(r.admin_reply || "");
  const update = async (status, admin_reply) => {
    try {
      await api.patch(`/admin/requests/${r.id}`, { status, admin_reply });
      toast.success("Request updated");
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-lg border border-border bg-card p-6" data-testid={`request-card-${r.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-lg font-medium">{r.peptide_name}</p>
          <p className="text-xs text-muted-foreground">{r.client_name} · {r.client_email} · {fmtDate(r.created_at)}</p>
        </div>
        <div className="flex items-center gap-2">
          <RequestStatusBadge status={r.status} />
          <Select value={r.status} onValueChange={(v) => update(v, reply)}>
            <SelectTrigger className="w-32" data-testid={`request-status-select-${r.id}`}><SelectValue /></SelectTrigger>
            <SelectContent>{["new", "reviewed", "added", "declined"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      {r.details && <p className="mt-3 text-sm text-muted-foreground">{r.details}</p>}
      <div className="mt-4 flex gap-2">
        <Input placeholder="Reply to client (they'll see it)" value={reply} onChange={(e) => setReply(e.target.value)} data-testid={`request-reply-input-${r.id}`} />
        <Button variant="outline" onClick={() => update(r.status === "new" ? "reviewed" : r.status, reply)} data-testid={`request-reply-button-${r.id}`}>Send</Button>
      </div>
    </div>
  );
}

export default function Requests() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/requests").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <PageHeader eyebrow="Client wishlist" title="Peptide requests" />
      {list.length === 0 && <p className="py-10 text-center text-sm text-muted-foreground" data-testid="requests-empty">No requests yet.</p>}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">{list.map((r) => <RequestCard key={r.id} r={r} onChanged={load} />)}</div>
    </div>
  );
}
